import * as React from "react";

const cx = (...xs: Array<string | false | null | undefined>) =>
  xs.filter(Boolean).join(" ");

export const Card = ({
  className = "",
  ...p
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cx(
      "rounded-2xl border border-white/10 bg-slate-950/70",
      className
    )}
    {...p}
  />
);

export const CardHeader = ({
  className = "",
  ...p
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cx("px-4 pt-3", className)} {...p} />
);

export const CardTitle = ({
  className = "",
  ...p
}: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h3
    className={cx(
      "text-base font-semibold tracking-tight text-slate-100",
      className
    )}
    {...p}
  />
);

export const CardDescription = ({
  className = "",
  ...p
}: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cx("text-sm text-slate-400", className)} {...p} />
);

export const CardContent = ({
  className = "",
  ...p
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cx("px-4 pb-4", className)} {...p} />
);

export const CardFooter = ({
  className = "",
  ...p
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cx("px-4 pb-3 pt-2", className)} {...p} />
);

// Keep default for compatibility with `import Card from "..."`
export default Card;